import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import gsap from 'gsap'

export function Header() {
  const headerRef = useRef<HTMLElement>(null)
  const logoRef = useRef<HTMLAnchorElement>(null)
  const navLinksRef = useRef<HTMLDivElement>(null)
  const [isScrolled, setIsScrolled] = useState(false)

  const { t } = useTranslation()

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

      // Logo fade in from left
      tl.fromTo(
        logoRef.current,
        { opacity: 0, x: -20 },
        { opacity: 1, x: 0, duration: 0.8 },
        0.3
      )

      // Nav links stagger fade in from top
      if (navLinksRef.current) {
        const links = navLinksRef.current.querySelectorAll('a')
        tl.fromTo(
          links,
          { opacity: 0, y: -10 },
          { opacity: 1, y: 0, duration: 0.6, stagger: 0.12 },
          0.5
        )
      }
    }, headerRef)

    return () => ctx.revert()
  }, [])

  return (
    <header
      ref={headerRef}
      className={`fixed top-[40px] left-0 right-0 z-50 transition-all duration-300 ${isScrolled
        ? 'bg-bg-base/80 backdrop-blur-md border-b border-white/[0.06]'
        : 'bg-transparent'
        }`}
    >
      <div className="container">
        <nav className="flex items-center justify-between py-sm md:py-md -mr-1 md:-mr-0">
          {/* Logo */}
          <Link ref={logoRef} to="/" className="flex items-center opacity-0">
            <img
              src="/logo.svg"
              alt="digem"
              width={80}
              height={26}
              className="block"
            />
          </Link>

          {/* Navigation */}
          <div ref={navLinksRef} className="hidden sm:flex items-center">
            <a
              href="/#faq"
              className="nav-link-glow px-sm py-xs text-sm text-text-primary/78 hover:text-text-primary/92 transition-colors font-body-en opacity-0"
            >
              {t('nav.faq')}
            </a>
          </div>
        </nav>
      </div>
    </header>
  )
}
